import $ from "jquery";

import GeneralKenticoFileUploadForm from './form-general-kentico-file-upload';

class WarrantyRequestPublicForm extends GeneralKenticoFileUploadForm
{
    /**
     * Add post data specific to this form to the given postData. This method is called
     * prior to posting the data.
     * @param {object} postData - post data object to add post data to 
     */
    addPostData(postData) {
        super.addPostData(postData);
        postData["preferredcontactmethod"] = $(this.config.additionalDataFieldIds.PreferredContactMethod).val();
        return postData;
    }
}

export { WarrantyRequestPublicForm as default }
